import React, { CSSProperties, useState } from 'react';
import { ContentState, convertToRaw, EditorState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import './ContentEditor.css';
import { Box, Button, FormGroup, styled, SxProps, TextField, Typography, useTheme } from '@mui/material';
import { convertFromHTML, convertToHTML } from 'draft-convert';
import DOMPurify from 'dompurify';
import { client } from '../../../utils/axios-client';

function createMarkup(html: string) {
    return {
        __html: DOMPurify.sanitize(html),
    };
}
export enum TokenType {
    None,
    Lead,
    Other,
}

type Props = {
    withTokens?: boolean;
    tokenType?: TokenType;
    html: string;
    onChange: (newState: string) => void;
    showToolbar?: boolean;
    textMode?: boolean;
    disabled?: boolean;
    sx?: CSSProperties;
    error?: boolean;
    height?: string;
};

const WysiwygEditor = ({
    html,
    onChange,
    tokenType = TokenType.None,
    showToolbar = true,
    withTokens = true,
    textMode = false,
    disabled = false,
    error = false,
    sx,
    height = '30vh',
}: Props) => {
    const [editorState, setEditorState] = React.useState(() => EditorState.createEmpty());
    const [tokens, setTokens] = useState([]);
    const theme = useTheme();

    React.useEffect(() => {
        const loadTokens = async () => {
            const response = await client.get('/api/options/editortokens', { params: { tokenType } });

            setTokens(response.data);
        };

        if (withTokens) {
            loadTokens();
        } else {
            setTokens([]);
        }
    }, [tokenType, withTokens]);

    React.useEffect(() => {
        const blocksFromHTML = convertFromHTML(html ?? '');
        setEditorState(EditorState.createWithContent(blocksFromHTML));
    }, [html]);

    //React.useEffect(() => {

    //}, [editorState])

    const onBlur = () => {
        if (textMode) {
            onChange(editorState.getCurrentContent().getPlainText());
        } else {
            const res = convertToHTML(editorState.getCurrentContent());

            onChange(res);
        }
    };

    return (
        <Editor
            editorState={editorState}
            onBlur={onBlur}
            onEditorStateChange={setEditorState}
            editorClassName="editor-class"
            toolbarClassName="toolbar-class"
            toolbarStyle={{ background: '#312d4bff', color: '#312d4bff' }}
            toolbarHidden={!showToolbar || textMode}
            wrapperStyle={{
                border: `1px solid ${!error ? theme.palette.divider : theme.palette.error.main}`,
                margin: 0,
                height: '80%',
            }}
            readOnly={disabled}
            mention={{
                separator: ' ',
                trigger: '#',
                suggestions: tokens,
            }}
        />
    );
};

export { WysiwygEditor, convertToHTML };
export default WysiwygEditor;
